import { render } from "./configurator.vue?vue&type=template&id=48924b23&ts=true"
import script from "./configurator.vue?vue&type=script&lang=ts"
export * from "./configurator.vue?vue&type=script&lang=ts"

import "./configurator.vue?vue&type=style&index=0&id=48924b23&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__